import {
    EMPLOYEE_TYPE_FETCHING,
    EMPLOYEE_TYPE_FAILED,
    EMPLOYEE_TYPE_SUCCESS,
  } from "./types";
  import EmployeeTypeService from "../services/employee-type.service";
  
  
  export const getEmployeeTypeByidCompany = (query) => async (dispatch) => {
    try {
      dispatch({
        type: EMPLOYEE_TYPE_FETCHING,
      });
      const res = await EmployeeTypeService.getEmployeeTypeByidCompany(query);
      if (res) {
        dispatch({
          type: EMPLOYEE_TYPE_SUCCESS,
          payload: res.data,
        });
      }
    } catch (error) {
      dispatch({
        type: EMPLOYEE_TYPE_FAILED,
      });
    }
  };
  
  export const addEmployeeType = (data) => async () => {
    try {
      const res = EmployeeTypeService.addEmployeeType(data);
      if (res) {
        return res;
      }
    } catch (error) {
      console.log(error);
      return "Error";
    }
  };
  
  export const deleteEmployeeType = (idEmployeeType) => async () => {
    try {
      const res = EmployeeTypeService.deleteEmployeeType(idEmployeeType);
      if (res) {
        return res;
      }
    } catch (error) {
      console.log(error);
      return "Error";
    }
  };
  
  export const updateEmployeeType = (data) => async () => {
    try {
      const res = EmployeeTypeService.updateEmployeeType(data);
      if (res) {
        return res;
      }
    } catch (error) {
      console.log(error);
      return "Error";
    }
  };
  
  
  